import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Default from './components/layouts/Default';
import HomeLayout from './components/layouts/HomeLayout.vue';
import SplashLayout from './components/layouts/SplashLayout.vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VuePageTransition from 'vue-page-transition';
import VueMeta from 'vue-meta';
import vueCountryRegionSelect from 'vue-country-region-select';

// CSS files
// import 'https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Source+Serif+Pro:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700;1,900&display=swap';
// import './assets/css/bootstrap.min.css';
// import './assets/css/all.min.css';
// import './assets/css/fontawesome.css';
// import './assets/css/default.css';
// import './assets/css/style.css';
// import './assets/css/responsive.css';

Vue.use(VueMeta);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VuePageTransition);
Vue.use(vueCountryRegionSelect);
Vue.config.productionTip = false;
Vue.component('default-layout', Default);
Vue.component('splash-layout', SplashLayout);
Vue.component('home-layout', HomeLayout);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
